import { ComponentProps } from 'react';
import styled from 'styled-components';

import { EditorAccessTier } from 'dashboard/apps/InquiryTemplateEditor/hooks/useIsEditableWithOptions';
import useLearnMoreEventClick from 'dashboard/components/ProductUpsellTooltip/useLearnMoreEventClick';
import { Feature } from 'dashboard/models/inquiry-template-version';
import Tooltip from 'design-system/components/Tooltip';

export enum ProductUpsellLevel {
  Starter = 'Starter',
  Essential = 'Essential',
  Growth = 'Growth',
  Enterprise = 'Enterprise',
}

export const getProductUpsellLevel = (accessTier: EditorAccessTier) => {
  switch (accessTier) {
    case EditorAccessTier.InquiriesBasic:
      return ProductUpsellLevel.Essential;
    case EditorAccessTier.InquiriesEnhanced:
      return ProductUpsellLevel.Growth;
    default:
      return ProductUpsellLevel.Starter;
  }
};

type ProductUpsellTooltipProps = {
  learnMoreId: string;
  accessTier: EditorAccessTier;
  productUpsellLevel?: ProductUpsellLevel;
  customContent?: string;
  feature?: Feature | null;
};

const StyledLink = styled.a`
  display: inline;
  font-weight: ${({ theme }) => theme.buttonFontWeight};
`;

export const ProductUpsellTooltip = ({
  productUpsellLevel,
  customContent,
  feature,
  accessTier,
  learnMoreId,
  ...tooltipProps
}: ProductUpsellTooltipProps & ComponentProps<typeof Tooltip>) => {
  const { linkElementId, onLearnMoreClick } = useLearnMoreEventClick({ id: learnMoreId });

  return (
    <Tooltip side='top' {...tooltipProps}>
      <span style={{ maxWidth: '200px' }}>
        {customContent ?? `This feature is not available on your plan. `}
        <StyledLink
          href='#'
          target='_blank'
          id={linkElementId}
          rel='noreferrer'
          onClick={(e) => {
            e.preventDefault();
            onLearnMoreClick({
              feature,
              accessTier: accessTier as Exclude<EditorAccessTier, EditorAccessTier.Any>,
            });
          }}
        >
          Learn more
        </StyledLink>
      </span>
    </Tooltip>
  );
};
